import gql from 'graphql-tag';
import analyticsApolloClient from './analyticsApolloClient';

const TRACK_EVENT = gql`
  mutation analytics($input: AnalyticsInput!) {
    analytics(input: $input) {
      uuid: id
    }
  }
`;

export default async (action: string, actionArguments: string[] = []) => {
  try {
    await analyticsApolloClient.mutate({
      mutation: TRACK_EVENT,
      variables: {
        input: {
          action,
          action_arguments: actionArguments,
        },
      },
    });
  } catch (e) {
    const error = new Error(`Could not send analytics action: ${e.message}`);

    window.Raven.captureException(error, { extra: { action } });
  }
};
